import { useSelector } from 'react-redux';

interface UserSession {
  token: string | null;
}

interface RootState {
  userSession?: UserSession;
  [key: string]: unknown;
}

/**
 * Hook para verificar se o usuário está autenticado.
 * Verifica se há um token JWT válido.
 * O token deve ser decodificado pelo Volto quando necessário.
 */
export const useIsLoggedIn = (): boolean => {
  const userSession = useSelector((state: RootState) => state.userSession);
  return !!userSession?.token;
};

export default useIsLoggedIn;
